import { parseDay, type CalendarView } from './dates'

/** `/calendar` search params. Filters are ids; `date` anchors the visible range. */
export interface CalendarSearch {
  view?: CalendarView
  date?: string
  display?: string
  location?: string
  campaign?: string
}

const VIEWS = new Set(['week', 'month', 'day'])
const str = (v: unknown): string | undefined => (typeof v === 'string' && v.length > 0 ? v : undefined)

export function validateCalendarSearch(s: Record<string, unknown>): CalendarSearch {
  const date = str(s.date)
  return {
    view: typeof s.view === 'string' && VIEWS.has(s.view) && s.view !== 'week' ? (s.view as CalendarView) : undefined,
    date: date && parseDay(date) !== null ? date : undefined,
    display: str(s.display),
    // A display already implies its location.
    location: str(s.display) ? undefined : str(s.location),
    campaign: str(s.campaign),
  }
}
